import { Link } from "react-router-dom";

interface MangaCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  updateChapter: string;
  tags: string[];
  size?: "sm" | "md" | "lg";
}

export default function MangaCard({
  id,
  title,
  author,
  cover,
  rating,
  status,
  updateChapter,
  tags,
}: MangaCardProps) {
  return (
    <Link
      to={`/manga/${id}`}
      className="group block cursor-pointer"
    >
      <div
        className="relative overflow-hidden rounded-lg bg-background-200 mb-3"
        style={{ width: "100%", aspectRatio: "3/4" }}
      >
        <img
          src={cover}
          alt={title}
          title={`${title} - 九妖漫画网免费漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center justify-between">
            <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-0.5 rounded-full">
              {rating}分
            </span>
            <span className={`text-white text-xs px-2 py-0.5 rounded-full ${
              status === "连载中" ? "bg-accent-500/90" : "bg-secondary-500/90"
            }`}>
              {status}
            </span>
          </div>
        </div>
      </div>
      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{author} · {updateChapter}</p>
      <div className="flex flex-wrap gap-1 mt-2">
        {tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}